<template>
    <div v-resize:debounce.300="refreshChart" ref="chartContainer">
        <div style="position: absolute; width: 0; height: 0;">
            <!--https://jsfiddle.net/ezanker/0nmfz6cd/5/-->
            <!--http://iros.github.io/patternfills/sample_svg.html-->
            <svg height="10" width="10" xmlns="http://www.w3.org/2000/svg" version="1.1">
                <defs>
                    <pattern id="circles-0" width="4" patternUnits="userSpaceOnUse" height="4"
                             patternTransform="rotate(45 0 0)">
                        <line x1="0" y1="0" x2="0" y2="2" style="stroke:black; stroke-width:1"/>
                    </pattern>
                    <pattern id="diagonal-stripe-0" patternUnits="userSpaceOnUse" width="10" height="10"
                             patternTransform="rotate(45 0 0)">
                        <line x1="0" y1="0" x2="0" y2="10" style="stroke:black; stroke-width:1"/>
                    </pattern>
                    <pattern id="diagonal-stripe-1" patternUnits="userSpaceOnUse" width="10" height="10">
                        <image
                            xlink:href="data:image/svg+xml;base64,PHN2ZyB4bWxucz0naHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmcnIHdpZHRoPScxMCcgaGVpZ2h0PScxMCc+CiAgPHJlY3Qgd2lkdGg9JzEwJyBoZWlnaHQ9JzEwJyBmaWxsPSd3aGl0ZScvPgogIDxwYXRoIGQ9J00tMSwxIGwyLC0yCiAgICAgICAgICAgTTAsMTAgbDEwLC0xMAogICAgICAgICAgIE05LDExIGwyLC0yJyBzdHJva2U9J2JsYWNrJyBzdHJva2Utd2lkdGg9JzEnLz4KPC9zdmc+Cg=="
                            x="0" y="0" width="10" height="10"></image>
                    </pattern>
                    <pattern id="diagonal-stripe-2" patternUnits="userSpaceOnUse" width="10" height="10">
                        <image
                            xlink:href="data:image/svg+xml;base64,PHN2ZyB4bWxucz0naHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmcnIHdpZHRoPScxMCcgaGVpZ2h0PScxMCc+CiAgPHJlY3Qgd2lkdGg9JzEwJyBoZWlnaHQ9JzEwJyBmaWxsPSd3aGl0ZScvPgogIDxwYXRoIGQ9J00tMSwxIGwyLC0yCiAgICAgICAgICAgTTAsMTAgbDEwLC0xMAogICAgICAgICAgIE05LDExIGwyLC0yJyBzdHJva2U9J2JsYWNrJyBzdHJva2Utd2lkdGg9JzInLz4KPC9zdmc+"
                            x="0" y="0" width="10" height="10"></image>
                    </pattern>
                    <pattern id="circles-1" patternUnits="userSpaceOnUse" width="10" height="10">
                        <image
                            xlink:href="data:image/svg+xml;base64,PHN2ZyB4bWxucz0naHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmcnIHdpZHRoPScxMCcgaGVpZ2h0PScxMCc+CiAgPHJlY3Qgd2lkdGg9JzEwJyBoZWlnaHQ9JzEwJyBmaWxsPSJ3aGl0ZSIgLz4KICA8Y2lyY2xlIGN4PSIxIiBjeT0iMSIgcj0iMSIgZmlsbD0iYmxhY2siLz4KPC9zdmc+"
                            x="0" y="0" width="10" height="10"></image>
                    </pattern>
                </defs>
            </svg>
        </div>
        <img v-if="printMode" class="ui fluid image" :src="image"/>
        <button v-show="!printMode" class="ui basic icon button export tiny" @click.prevent="exportAsExcel"
                title="Export to Excel"><i
            class="download icon"></i></button>
        <div v-show="!printMode" ref="widget"></div>
    </div>
</template>

<script type="text/babel">
import _ from 'lodash';
import resize from 'vue-resize-directive';
import { momentMixin } from '../../../shared/mixins';

export default {
    name: 'kendo-chart',

    directives: {
        resize
    },

    props: {
        title: {
            type: String
        },
        type: {
            type: String
        },
        stack: [Boolean, Object],
        category: {
            type: Object
        },
        series: {
            type: Array
        },
        label: {
            type: Object
        },
        legend: {
            type: Object,
            default: () => ({})
        },
        dataSource: {
            type: Array
        },
        format: {
            type: String,
            default: '{0:n2}'
        },
        gap: {
            type: Number,
            default: 0.5
        },
        height: {
            type: Number,
            default: Math.round(Math.max(document.body.scrollHeight, document.body.offsetHeight, document.documentElement.clientHeight, document.documentElement.scrollHeight, document.documentElement.offsetHeight) / 3)
        },
        colors: {
            type: Array,
            default: () => ['#1ABC9C', '#3498DB', '#9B59B6', '#34495E', '#E74C3C', '#E67E22', '#F1C40F', '#ECF0F1']
        },
        fontSize: {
            type: Number,
            default: 11
        },
        valueAxis: {
            type: [Object, Array],
            default: () => ({})
        },
        categoryAxis: {
            type: Object,
            default: () => ({})
        },
        printMode: {
            type: Boolean
        },
        printSize: {
            type: Object,
            default: () => ({
                height: Math.round(Math.max(document.body.scrollHeight, document.body.offsetHeight, document.documentElement.clientHeight, document.documentElement.scrollHeight, document.documentElement.offsetHeight) / 3),
                width: window.outerWidth
            })
        }
    },

    data () {
        return {
            config: this.getWidgetConfig(),
            image: undefined,
            widget: undefined
        };
    },

    mixins: [momentMixin],

    methods: {
        getWidgetConfig () {
            let seriesLabel = {
                visible: false,
                font: `bold ${this.fontSize}px "Roboto Condensed"`,
                format: this.format
            };

            if (this.label) {
                seriesLabel = _.assign({}, seriesLabel, this.label);
            }

            _.forEach(this.series, s => {
                if (s.labels) {
                    s.labels = _.assign({}, seriesLabel, s.labels);
                }
            });

            let valueAxis;
            if (_.isArray(this.valueAxis)) {
                valueAxis = _.map(this.valueAxis, v =>
                    _.assign({}, {
                        majorGridLines: {
                            visible: false
                        },
                        labels: {
                            font: `bold ${this.fontSize}px "Roboto Condensed"`,
                            format: this.format
                        }
                    }, v)
                );
            } else {
                valueAxis = _.assign({}, {
                    majorGridLines: {
                        visible: false
                    },
                    labels: {
                        font: `bold ${this.fontSize}px "Roboto Condensed"`,
                        format: this.format
                    }
                }, this.valueAxis);
            }

            let categoryAxis;
            if (this.category) {
                categoryAxis = _.assign({}, {
                    field: this.category.field,
                    majorGridLines: {
                        visible: false
                    },
                    labels: {
                        visible: true,
                        rotation: 'auto',
                        font: `bold ${this.fontSize}px "Roboto Condensed"`
                    }
                }, this.categoryAxis);
            }

            const config = {
                renderAs: 'canvas',
                theme: 'bootstrap',
                title: {
                    visible: !!this.title,
                    text: this.title
                },
                chartArea: {
                    height: this.height,
                    background: 'transparent',
                    margin: {
                        top: 10,
                        left: 10,
                        bottom: 10,
                        right: 10
                    }
                },
                legend: _.assign({}, {
                    position: 'top',
                    margin: {
                        bottom: 15
                    },
                    item: {
                        visual: (e) => {
                            const color = e.series.markers ? (this.legend.type === 'marker' ? e.series.markers.background || '#202020' : e.options.markers.background) : e.series.color;
                            const labelColor = e.options.labels.color;
                            const rect = new kendo.geometry.Rect([0, 0], [(this.fontSize * e.series.name.length) + 20, 50]);
                            const layout = new kendo.drawing.Layout(rect, {
                                spacing: 5,
                                alignItems: 'center'
                            });

                            let marker;
                            const style = {
                                fill: {
                                    color: color
                                },
                                stroke: {
                                    width: 1,
                                    color: _.some(['#ffffff', '#fff', 'rgb(255, 255, 255)'], c => c === color.toLowerCase()) ? '#202020' : color
                                }
                            };

                            const markerType = (e.series.markers && this.legend.type === 'marker') ? e.series.markers.type || 'rect' : this.legend.type;
                            switch (markerType) {
                            case 'circle':
                                marker = new kendo.drawing.Circle(new kendo.geometry.Circle([0, 0], 5), style);
                                break;
                            case 'triangle':
                                marker = new kendo.drawing.Path(style).moveTo(6, 0).lineTo(12, 12).lineTo(0, 12).close();
                                break;
                            case 'line':
                                marker = new kendo.drawing.Path(style).moveTo(10, 4).lineTo(10, 8).lineTo(0, 8).lineTo(0, 4).close();
                                break;
                            default:
                                if (e.series.markers && e.series.markers.rotation) {
                                    marker = new kendo.drawing.Path(style).moveTo(6.5, 0).lineTo(13, 6.5).lineTo(6.5, 13).lineTo(0, 6.5).close();
                                } else {
                                    marker = new kendo.drawing.Path(style).moveTo(10, 0).lineTo(10, 10).lineTo(0, 10).lineTo(0, 0).close();
                                }
                            }

                            const label = new kendo.drawing.Text(e.series.name, [0, 0], {
                                fill: {
                                    color: labelColor
                                },
                                font: `bold ${this.fontSize}px "Roboto Condensed"`
                            });

                            layout.append(marker, label);
                            layout.reflow();

                            return layout;
                        }
                    }
                }, this.legend),
                seriesDefaults: {
                    type: this.type,
                    stack: this.stack,
                    gap: this.gap,
                    spacing: 0,
                    labels: seriesLabel || false,
                    missingValues: 'gap',
                    tooltip: {
                        visible: true,
                        format: this.format
                    },
                    area: {
                        line: {
                            style: 'smooth'
                        }
                    }
                },
                series: this.series,
                seriesColors: this.colors,
                valueAxis,
                tooltip: {
                    visible: true
                }
            };

            if (categoryAxis) {
                config.categoryAxis = categoryAxis;
            }

            if (this.dataSource) {
                config.dataSource = {
                    data: this.dataSource
                };
            }

            return config;
        },

        exportAsExcel () {
            const rows = [{
                cells: _.concat([{ value: this.category.name }], _.map(this.dataSource, (val, key) => ({
                    value: val[this.category.field]
                })))
            }];
            _.forEach(this.series, (val, key) =>
                rows.push({
                    cells: _.concat([{ value: val.name }], _.map(this.dataSource, (v, k) => ({
                        value: v[val.field]
                    })))
                })
            );
            const workbook = new kendo.ooxml.Workbook({
                sheets: [
                    {
                        columns: _.map(_.range(0, this.dataSource.length + 1), () => ({ autoWidth: true })),
                        rows
                    }
                ]
            });
                // save the file as Excel file with extension xlsx
            kendo.saveAs({
                dataURI: workbook.toDataURL(),
                fileName: `${this.formatDate(new Date(), 'YYYY_MM_DD_hh_mm_ss')}_gig_chart_table.xlsx`
            });
        },

        exportChart () {
            this.widget.exportSVG().done((data) => {
                kendo.saveAs({
                    dataURI: data,
                    fileName: `${this.formatDate(new Date(), 'YYYY_MM_DD_hh_mm_ss')}_gig_chart_image.svg`
                });
            });
        },

        generateImage () {
            try {
                this.widget.exportImage({
                    height: this.printSize.height,
                    width: this.printSize.width
                }).done((image) => {
                    this.image = image;
                });
            } catch (err) {
                console.log(err);
            }
        },

        refreshChart () {
            if (!this.printMode && this.widget) {
                if (this.widget.element.height() !== this.height) {
                    const chartArea = Object.assign({}, this.config.chartArea, {
                        height: this.height
                    });
                    this.widget.setOptions({ chartArea });
                } else if (this.widget.element.width() !== this.widget._width) {
                    this.widget.refresh();
                    this.widget._width = this.widget.element.width();
                }
            }
        }
    },

    mounted () {
        this.widget = new kendo.dataviz.ui.Chart(this.$refs.widget, this.config);
    },

    beforeDestroy () {
    },

    destroyed () {
        this.widget.destroy();
    },

    watch: {
        printMode (enabled) {
            if (enabled) {
                return this.generateImage();
            }
        },

        dataSource (val) {
            if (this.label) {
                const seriesLabel = this.label;
                seriesLabel.font = `bold ${this.fontSize}px "Roboto Condensed"`;
                seriesLabel.format = this.format;
                seriesLabel.rotation = val.length <= 12 ? 0 : 270;
                this.config.seriesDefaults.labels = seriesLabel;
                this.widget.setOptions(this.config);
            }

            this.widget.setDataSource(new kendo.data.DataSource({ data: val }));
        },

        category (newVal, oldVal) {
            if (!_.isEqual(newVal, oldVal)) {
                const categoryAxis = Object.assign({}, (this.config || {}).categoryAxis, {
                    field: newVal.field
                });
                this.widget.setOptions({ categoryAxis });
            }
        },

        series (newVal, oldVal) {
            if (!_.isEqual(newVal, oldVal)) {
                this.widget.setOptions({ series: newVal });
            }
        }
    }
};
</script>

<style lang="scss" rel="stylesheet/scss" scoped>

    .button.export {
        position: absolute;
        top: 0.5rem;
        right: 0.5rem;
        z-index: 1;
    }
</style>



// WEBPACK FOOTER //
// src/modules/shared/components/kendo-chart/kendo-chart.component.vue